import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useEffect, useState } from "react"
import SssAccordionItem from "../../components/shared/accordion/SssAccordionItem"
import { useSelector } from "react-redux"
import { getEgeyurtIletisim } from "../../features/admin/adminSlice"
import { useDispatch } from "react-redux"

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;
    }

    .titles {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
        margin-bottom: 30px;
    }
    .list{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .row{
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 10px;
            padding-inline: 10px;
            color: ${({ theme }) => theme.mainTextColor};
            text-align: center;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            background-color: var(--color-light);
            padding-block: 20px;
            border-radius: 5px;
        }
    }
}

@media (max-width: 850px){
    .row{
        font-size: var(--font-size-xs) !important;
    }
  
}
`
const titles = ["Birim", "Telefon", "İşlemler"];

const Iletisim = () => {

    const { egeyurtIletisimList } = useSelector((state) => state.admin);
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getEgeyurtIletisim());
    }, []);

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"İletişim"} position='sticky'/>
      <div className="content">
        <div className="titles">
            {titles.map((item) => (
                <p>{item}</p>
            ))}
        </div>
        <div className="list">
            {
                egeyurtIletisimList?.map((item) => (
                    <div className="row">
                        <p>{item?.tittle}</p>
                        <p>{item?.phoneNumber}</p>
                        <p>{item?.email}</p>
                    </div>
                ))
            }
        </div>
      </div>
    </div>
  </Container>
  )
}

export default Iletisim